import { Component, ErrorInfo } from 'react';

import { PageError } from 'components/layout/PageError';

import * as T from './ErrorBoundary.types';

export class ErrorBoundary extends Component<
  T.IErrorBoundaryProps,
  T.IErrorBoundaryState
> {
  public state: T.IErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): T.IErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log(error, errorInfo);
    // Можно логировать ошибку, но sentry и так это делает автоматом
  }

  public componentDidMount() {}

  public render() {
    if (this.state.hasError) {
      return (
        <PageError showReloadPage>
          Произошла непредвиденная ошибка, попробуйте перезагрузить страницу
        </PageError>
      );
    }

    return this.props.children;
  }
}
